import styled, { css, createGlobalStyle } from 'styled-components'

import { venture } from '../../../config'
import { gFontUrls, ballyFonts } from '../../../components/fontStyles'

export const RemoveMargin = styled.div`
  width: 100%;
  margin: -92px;
`

export const FontStyle = createGlobalStyle`
  @import url("${gFontUrls.nunitoSans}");
  
  ${() =>
    venture === 'virgingames' &&
    css`
      @import url(${gFontUrls.kumbhSans});

      body {
        font-family: Nunito Sans, sans-serif;
      }
    `}

  ${() =>
    venture === 'virgincasino' &&
    css`
      @import url(${gFontUrls.kumbhSans});

      body {
        font-family: Nunito Sans, sans-serif;
      }
    `}

  ${() =>
    venture === 'jackpotjoy' &&
    css`
      @import url(${gFontUrls.kumbhSans});

      body {
        font-family: Nunito Sans, sans-serif;
      }
  `} 


  ${() =>
    venture === 'rainbowrichescasino' &&
    css`
      @import url(${gFontUrls.EBGaramond});
      @import url(${gFontUrls.kumbhSans});

      body {
        font-family: "EB Garamond", serif;
      }
  `}

  ${() =>
    venture === 'doublebubblebingo' &&
    css`
      @import url(${gFontUrls.kumbhSans});

      body {
        font-family: Kumbh Sans, sans-serif;
      }
  `}

${() =>
    venture === 'ballycasinonj' &&
    css`
      @import url(${gFontUrls.kumbhSans});

      body {
        font-family: Nunito Sans, sans-serif;
      }

      ${ballyFonts}
  `}

  ${() =>
    venture === 'ballybetca' &&
    css`
      @import url(${gFontUrls.kumbhSans});

      body {
        font-family: Nunito Sans, sans-serif;
      }

      ${ballyFonts}
  `}
          
  ${() =>
    venture === 'ballybetaz' &&
    css`
      @import url(${gFontUrls.kumbhSans});

      body {
        font-family: BallyThrill-Regular, sans-serif;
      }

      ${ballyFonts}
  `}

  ${() =>
    venture === 'botemania_es' &&
    css`
      @import url(${gFontUrls.kumbhSans});

      body {
        font-family: Kumbh Sans, sans-serif;
      }
    `}

  ${() =>
    venture === 'monopolycasino' &&
    css`
      @import url(${gFontUrls.outfit});

      body {
        font-family: Outfit, sans-serif;
      }
  `}

  ${() =>
    venture === 'monopolycasino_es' &&
    css`
      @import url(${gFontUrls.outfit});
  
      body {
        font-family: Outfit, sans-serif;
      }
    `}
  
`
